export default __webpack_public_path__ + "static/media/Solar2D.b8b54175.png";